@if (form) {
  <div class="accounting-process__content p-3 my-3" [class.accounting-process__content--add]="isNew">
    <div class="px-1 pb-4 d-flex align-items-center">
      <div class="pe-4 w-25" [class.has-error]="form.controls.name.invalid">
        <strong class="d-block text-nowrap text-dark-grey">
          @if (isNew) {
            Add New Accounting Operation
          } @else {
            Accounting Operation
          }
        </strong>
        <input aria-label="Operation Name" type="text" class="form-control" [formControl]="form.controls.name"
          placeholder="Add new value" data-cy="OperationNameInput">
        </div>
        <div class="pe-4 w-25"
          [class.has-error]="form.controls.anchorTemplateId.invalid && form.controls.anchorTemplateId.touched">
          <strong class="d-block text-nowrap text-dark-grey">
            Revenue Allocation Template
          </strong>
          <select aria-label="Revenue Allocation Template" class="form-select"
            [formControl]="form.controls.anchorTemplateId" data-cy="AnchorTemplateSelect">
            <option [ngValue]="null">Select</option>
            @for (t of anchorTemplatesRevenue; track t) {
              <option [ngValue]="t.templateID">
                {{ t.templateName }}
              </option>
            }
          </select>
        </div>
        @if(costAllocationTemplateId !== -1)
          {
          <div class="pe-4 w-25"
            [class.has-error]="form.controls.costAnchorTemplateId.invalid && form.controls.costAnchorTemplateId.touched">
            <strong class="d-block text-nowrap text-dark-grey">
              Cost Allocation Template
            </strong>
            <select aria-label="Cost Allocation Template" class="form-select"
              [formControl]="form.controls.costAnchorTemplateId" data-cy="CostAnchorTemplateSelect">
              <option [ngValue]="null">None</option>
              @for (t of anchorTemplatesCost; track t) {
                <option [ngValue]="t.templateID">
                  {{ t.templateName }}
                </option>
              }
            </select>
          </div>
        }
        <div class="pe-4 w-25"
          [class.has-error]="form.controls.operationType.invalid && form.controls.operationType.touched">
          <strong class="d-block text-nowrap text-dark-grey">
            Operation Type
          </strong>
          <select aria-label="Operation Type" class="form-select" [formControl]="form.controls.operationType"
            data-cy="OperationTypeSelect">
            @for (type of operationTypes; track $index) {
              <option [ngValue]="type.id">
                {{ type.name }}
              </option>
            }
          </select>
        </div>
        <button class="align-self-end btn btn-info btn-sm ms-2" (click)="saveAccountingOperation()"
          [disabled]="!canSave() || form.controls.costAnchorTemplateId.disabled"
          [hidden]="!canSave() || (isSaving$ | async)" data-cy="SaveButton">
          Save
        </button>
      </div>
      @if (showRevAccountsRequiredWarning()) {
        <div class="alert alert-danger mx-3 mb-0" role="alert">
          <i class="fas fa-exclamation-triangle me-2"></i>
          <strong>Revenue Allocation accounts are required for all events.</strong> Please configure revenue allocation accounts in each event below before saving.
        </div>
      }
      @if (showCostAccountsRequiredWarning()) {
        <div class="alert alert-danger mx-3 mb-0" role="alert">
          <i class="fas fa-exclamation-triangle me-2"></i>
          <strong>Cost Allocation accounts are required for all events.</strong> Please configure cost allocation accounts in each event below before saving.
        </div>
      }
      @if (anchorTemplate && operation?.id) {
        <div ngbAccordion #acc="ngbAccordion" [closeOthers]="false" [destroyOnHide]="false"
          >
          <div ngbAccordionItem="triggers" #triggers="ngbAccordionItem" [collapsed]="false">
            <div ngbAccordionHeader aria-level="2">
              <button class="accordion-button panel__title d-flex justify-content-between align-items-center"
                [ngClass]="{'collapsed' : triggers.collapsed}" ngbAccordionButton data-cy="TriggersToggleAccordion">
                <span class="cursor-pointer">
                  @if (isNew) {
                    Add
                    }Triggers
                  </span>
                  <span class="panel__ops">
                    @if (triggersComplete) {
                      <span class="d-inline-block text-success-light">
                        <i class="fas fa-circle-check"></i>
                      </span>
                    }
                    <span class="d-inline-block ms-3 text-center w-30px" data-cy="ExpandCollapseArrow">
                      <i class="fal fa-chevron-right cursor-pointer toggle-chevron p-1"
                        [title]="triggers.collapsed ? 'Expand' : 'Collapse'"
                        [attr.data-cy]="triggers.collapsed ? 'ToExpand' : 'ToCollapse'"
                      [class.open]="!triggers.collapsed"></i>
                    </span>
                  </span>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <rl-add-accounting-operation-triggers [triggersFormArray]="form.controls.triggers"
                      [anchorTemplate]="anchorTemplate" [disabled]="!form.valid">
                    </rl-add-accounting-operation-triggers>
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem="events" #events="ngbAccordionItem" [disabled]="!triggersComplete">
              <div ngbAccordionHeader aria-level="2">
                <button class="accordion-button panel__title d-flex justify-content-between align-items-center"
                  [ngClass]="{'collapsed' : events.collapsed}" ngbAccordionButton data-cy="EventsToggleAccordion">
                  <span class="cursor-pointer">
                    @if (isNew) {
                      Add
                      }Events
                    </span>
                    <span class="panel__ops">
                      @if (eventsComplete) {
                        <span class="d-inline-block text-success-light">
                          <i class="fas fa-circle-check"></i>
                        </span>
                      }
                      <span class="d-inline-block ms-3 text-center w-30px" data-cy="ExpandCollapseArrow">
                        <i class="fal fa-chevron-right cursor-pointer toggle-chevron p-1"
                          [title]="events.collapsed ? 'Expand' : 'Collapse'"
                          [attr.data-cy]="events.collapsed ? 'ToExpand' : 'ToCollapse'"
                          [class.open]="!events.collapsed">
                        </i>
                      </span>
                    </span>
                  </button>
                </div>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <rl-add-accounting-operation-events [eventsFormArray]="form.controls.events"
                        [anchorTemplate]="anchorTemplate" [accounts]="accounts" [accountGroups]="accountGroups"
                        [workflowTrigger]="workflowTrigger" [operationType]="selectedOperationType"
                        [costAnchorTemplateId]="form.controls.costAnchorTemplateId.value">
                      </rl-add-accounting-operation-events>
                    </ng-template>
                  </div>
                </div>
              </div>
              <ng-container *rlFeatureEnabled="featureKeys.AccountingProcessPhaseTwo">
                <div ngbAccordionItem="dates" #dates="ngbAccordionItem" [disabled]="!eventsComplete">
                  <div ngbAccordionHeader aria-level="2">
                    <button class="accordion-button panel__title d-flex justify-content-between align-items-center"
                      [ngClass]="{'collapsed' : dates.collapsed}" ngbAccordionButton data-cy="DateToggleAccordion">
                      <span class="cursor-pointer">
                        Date Population
                      </span>
                      <span class="panel__ops">
                        @if (datesComplete) {
                          <span class="d-inline-block text-success-light">
                            <i class="fas fa-circle-check"></i>
                          </span>
                        }
                        <span class="d-inline-block ms-3 text-center w-30px" data-cy="ExpandCollapseArrow">
                          <i class="fal fa-chevron-right cursor-pointer toggle-chevron p-1"
                            [title]="events.collapsed ? 'Expand' : 'Collapse'"
                            [attr.data-cy]="events.collapsed ? 'ToExpand' : 'ToCollapse'"
                            [class.open]="!events.collapsed">
                          </i>
                        </span>
                      </span>
                    </button>
                  </div>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <rl-add-accounting-operation-dates [datesFormArray]="form.controls.dates"
                          [anchorTemplate]="anchorTemplate" [anchorTemplatesDates]="anchorTemplatesDates"
                          [operationTriggers]="operationTriggers" [operationId]="$safeNavigationMigration(operation?.id)">
                        </rl-add-accounting-operation-dates>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          }
        </div>
      }

      <ng-template #anchorTemplateUpdateWarning let-prompt="prompt">
        <div>
          <p>
            Changing the Revenue Allocation Template will clear any configured Triggers, Events, or Date Population
            Settings. Are you sure you want to change the Revenue Allocation Template?
          </p>
        </div>
        <div class="text-end mt-3 w-100">
          <button class="btn btn-light btn-sm me-2" (click)="prompt.onConfirm.next(false)"
          data-cy="cancelButton">Cancel</button>
          <button class="btn btn-success btn-sm" (click)="prompt.onConfirm.next(true)"
          data-cy="ContinueButton">Continue</button>
        </div>
      </ng-template>